import Stat_Decor_Mob from "../../img/decor/stat_decor_mob.png";
import Stat_Decor_Desc from "../../img/decor/stat_decor_desc.png";


function  Statistic() {
    const statisticContent = [
        {
            number: '30+',
            text: 'спікерів',
            decor_mob: Stat_Decor_Mob,
            decor_desc: Stat_Decor_Desc,
        },
        {
            number: '400+',
            text: 'учасників офлайн',
            decor_mob: Stat_Decor_Mob,
            decor_desc: Stat_Decor_Desc,
        },
        {
            number: '5',
            text: 'панельні дискусії',
        }
    ];

    return (
        <section className="bg-[#FED84A] py-[60px]">

            <div className="container max-w-screen-xl mx-auto px-5">
                <div className="grid gap-14 md:grid-cols-3">
                    {statisticContent.map((item, index) => (
                        <div key={index} className="text-center relative w-full">
                            <span className="font-bold text-[45px] lg:text-[67px] leading-none">{item.number}</span>
                            <p className=""> {item.text}</p>
                            {item.decor_mob && (
                                <img src={item.decor_mob} alt="icon"
                                    className="max-w-[250px] absolute left-1/2 -translate-x-1/2 -bottom-8 md:hidden"
                                />
                            )}
                            {item.decor_desc && (
                                <img src={item.decor_desc} alt="icon"
                                    className="hidden h-[120px] absolute -right-8 -top-5 md:block"
                                />
                            )}
                        </div>
                    ))}
                </div>
            </div>

        </section>
    )
}

export default Statistic;